import { AxiosResponse } from "axios";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";
import * as ApiUrls from "./ApiUrl.CustomScorecardSettings";
import { CustomScorecard } from "../../Model/Dto/Scorecard/CustomScorecard";

export const CustomScorecardSettings = {
    getCustomFieldName: (typeId: number): Promise<AxiosResponse<CustomScorecard.PreferentialProcurementSettings>> => 
        axiosCoreInstance.get(`${ApiUrls.GetCustomFieldNames}?typeId=${typeId}`),
    saveCustomFieldName: (customFieldName : CustomScorecard.PreferentialProcurementSettings) : Promise<AxiosResponse<void>> => 
        axiosCoreInstance.put(ApiUrls.SaveCustomFieldNames, customFieldName)
}